import { BaseState } from '@/store/base-state';
import { TableOptions } from '@/types';
// import { default_lead } from '@/modules/leads/services';
import { Staffs, StaffsCertsFilters } from '@/modules/staffs/types';
import { OrganizationValidity } from '@/enums';

export default class CertificatesListState extends BaseState {
  certs: Staffs.StaffCerts[] = [];
  loading = false;
  filters: StaffsCertsFilters = {
    course_category_id: '',
    course_id: '',
    user_id: '',
    cert_validity: OrganizationValidity.VALID,
  };

  users: Staffs.StaffCertsUsers | [] = [];
  categories: Staffs.StaffCertsUsersCategories | [] = [];
  courses: Staffs.StaffCertsUsersCourses | [] = [];
  cert_validity: string[] = [];
  is_request_courses_not_available = false;

  table_options: TableOptions = {
    ...this.create_table_opts,
    sortBy: ['user_surname'],
    sortDesc: [true],
  };
}
